import axios from "axios";
import dayjs from "dayjs"
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"
import Loadingwrapper from "../../component/LoadingWrapper";
import Popup from "../../component/Popup";
import HashtagImages from "./HashtagImages";
import Hashtagtable from "./hashtagsTable";
import HashtagPageFilters from "./PageFilters";

const limit = 200;
const LOWESTDATEALLOWED = '01-07-2025'

const defaultDate = dayjs(LOWESTDATEALLOWED, 'DD-MM-YYYY').toDate()

const HashTagPage = () => {
  const [searchParams, setSearchParams] = useSearchParams({ from: LOWESTDATEALLOWED, to: "", geography: "All", page: "1" })
  const [hashTags, setHashtags] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedPopupTag, setSelectedPopupTag] = useState(null)
  const [total, setTotal] = useState(0)
  const [srStartCount, setSrStartCount] = useState(0)

  const getHashtags = async () => {
    setLoading(true)
    const response = await axios.get(`/api/hashtag?from=${searchParams.get('from')}&to=${searchParams.get('to')}&geography=${searchParams.get('geography')}&page=${searchParams.get('page') || '1'}`)
    setTotal(response.data.total)
    setHashtags(response.data.hashtags)
    setLoading(false)
  }

  const changePage = (newPage) => {
    setSearchParams(prev => {
      prev.set('page', newPage)
      return prev;
    })
  }

  useEffect(() => {
    getHashtags()
  }, [searchParams.get('from'), searchParams.get('to'), searchParams.get('geography'), searchParams.get('page')])

  useEffect(() => {
    const page = parseInt(searchParams.get('page') || '1')
    setSrStartCount(limit * (page - 1))
  }, [searchParams.get('page')])

  return <div>
    <h2 className="text-center text-lg my-2 font-semibold">Hashtag Leaderboard</h2>
    <HashtagPageFilters searchParams={searchParams} setSearchParams={setSearchParams} LOWESTDATEALLOWED={LOWESTDATEALLOWED} defaultDate={defaultDate} total={total} changePage={changePage} limit={limit} />
    <div className="flex m-2">

    </div>
    <Loadingwrapper loading={loading} className={"h-[80vh]"}>
      <Hashtagtable hashTags={hashTags} srStartCount={srStartCount} setselectedPopupTag={setSelectedPopupTag} />
    </Loadingwrapper>

    {
      selectedPopupTag ? <Popup isPopUp={selectedPopupTag} setIsPopUp={() => {
        setSelectedPopupTag(null)
      }}>
        <HashtagImages
          geography={searchParams.get('geography')}
          startDate={searchParams.get('from')}
          endDate={searchParams.get('to')}
          hashTag={selectedPopupTag}
        />
      </Popup>
        : null
    }

  </div>
}


export default HashTagPage
